<div class="flex justify-center">
    <div class="malou-text-40--bold text-malou-text-title"><span class="text-malou-pink">Top 20</span> restaurants du salon</div>
</div>
<div class="grid h-screen grid-flow-col grid-rows-10 gap-4 p-4 pb-[100px]" [@listAnimation]="diagnostics().length">
    @for (diag of diagnostics(); track diag.id; let i = $index) {
        <div class="flex flex-row items-center justify-between gap-x-4 rounded-lg bg-malou-dark p-4 text-center">
            <div class="malou-text-30--bold relative w-8">
                @if (i === 0) {
                    <img class="h-8 w-8" alt="trophy" [src]="Icon.TROPHY | imagePathResolver" />
                }
                @if (i === 1) {
                    <img class="h-8 w-8" alt="silver medal" [src]="Icon.SECOND_PLACE_MEDAL | imagePathResolver" />
                }
                @if (i === 2) {
                    <img class="h-8 w-8" alt="bronze medal" [src]="Icon.THIRD_PLACE_MEDAL | imagePathResolver" />
                }
                @if (diag.isNewDiagnostic()) {
                    <div class="absolute top-2 rotate-[345deg] gradient-text-primary">NEW</div>
                }
            </div>
            <div class="malou-text-28--bold text-malou-text-title">
                {{ diag.restaurant.name }}
            </div>
            <div
                class="malou-text-40--bold"
                [ngClass]="{
                    'text-malou-pink': diag.getTotalScoreRating() === DiagnosticRating.BAD,
                    'text-malou-yellow': diag.getTotalScoreRating() === DiagnosticRating.AVERAGE,
                    'text-malou-green': diag.getTotalScoreRating() === DiagnosticRating.GOOD,
                }">
                {{ diag.getTotalScore() }}
            </div>
        </div>
    }
</div>
